<div class="ftu-form " *ngIf="!authService?.FTUPanelData?.Validation">
    <div *ngIf="showFTUErr() && !rootScope.activeCustTab.IS_AAAS_ENABLED" class="error-wrapper">
        <f-alert variant="error">{{errorMessage}}
            <span *ngIf="authService.FTUPanelData?.APIFailure">
                <button (click)="authService.getFTUCredential()" class="btn-alert">Try again</button>
            </span>
        </f-alert>
    </div>
    <p *ngIf="!showValidtionInfo()">Enter all information below, then click Validate. </p>
    <div class="container validation-method">
        <form [formGroup]="authService.ftuPanelForm" *ngIf="!rootScope.activeCustTab.IS_AAAS_ENABLED">
            <span *ngFor="let group of authService?.FTUPanelData?.FTUContent">
                <!-- Add necessary HTML structure for groups -->

                <span *ngFor="let subgroup of group.subgroups">
                    <!-- Add necessary HTML structure for subgroups -->

                    <span *ngFor="let section of subgroup.sections">
                        <!-- Add necessary HTML structure for sections -->

                        <span *ngFor="let subgroup of section.sectionsubgroups">
                            <!-- Add necessary HTML structure for sectionsubgroups -->

                            <div class="row row-top-margin" *ngFor="let element of subgroup.elements">
                                <div class="col-md-6 single-col">
                                    <mat-form-field *ngIf="(element.title != 'DOB'&& element.title != 'HIREDATE')"
                                        appearance="fill" class="component-box">
                                        <mat-label>{{element.key}}</mat-label>
                                        <ng-container *ngIf="element.title=='LAST4SSN'">
                                            <input matInput [id]="element.key" [formControlName]="element.key"
                                                autoCompleteOff [maxlength]="4" />
                                        </ng-container>
                                        <ng-container *ngIf="element.title !='LAST4SSN'">
                                            <input matInput [id]="element.key" [formControlName]="element.key"
                                                autoCompleteOff />
                                        </ng-container>
                                    </mat-form-field>
                                    <mat-form-field *ngIf="element.title == 'HIREDATE'" appearance="fill"
                                        class="component-box">
                                        <mat-label>{{element.key}}</mat-label>
                                        <input matInput [id]="element.key" [formControlName]="element.key"
                                            autoCompleteOff />
                                        <mat-error *ngIf="errorHandling(element)">
                                            <i class="fa-solid fa-circle-xmark"></i>
                                            {{ errorHandling(element)}}
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field *ngIf="element.title == 'DOB'" appearance="fill"
                                        class="component-box">
                                        <mat-label>{{element.key}}</mat-label>
                                        <input matInput [id]="element.key" autoCompleteOff [max]="maxDate"
                                            [formControlName]="element.key" [matDatepicker]="picker1" />
                                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                        <mat-datepicker #picker1></mat-datepicker>
                                        <mat-error *ngIf="errorHandling(element)">
                                            <i class="fa-solid fa-circle-xmark"></i>
                                            {{ errorHandling(element)}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div *ngIf="element.title == 'FULLNAME'" class="col-md-6">
                                    <mat-checkbox [formControlName]="'additionalCheckboxKey'" class="verify-checkbox">
                                        The customer’s name is verified.</mat-checkbox>
                                </div>

                                <div *ngIf="authService.checkIVRConfirmation(section)" class="col-md-6 ivrCheck">
                                    <span class="data-verified"><i class="fa-light fa-circle-check"></i> Confirmed via
                                        IVR</span>
                                </div>
                            </div>

                        </span>
                    </span>
                </span>
            </span>
            <div class="secondary-fields hide">
                <p class="row" >Validate additional fields to confirm the customer's identity.</p>
                <div class="row row-top-margin">
                    <div class="col-md-6  single-col">
                      <mat-form-field appearance="fill" class="component-box date-field">
                        <mat-label>Hire Date</mat-label>
                        <input matInput id="hiredate" value="" />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row row-top-margin">
                    <div class="col-md-6  single-col">
                      <mat-form-field appearance="fill" class="component-box date-field">
                        <mat-label>Employer ID</mat-label>
                        <input matInput id="empId" value="" />
                      </mat-form-field>
                    </div>
                  </div>
            </div>
           
            <div class="row footer-btn" *ngIf="authService?.FTUPanelData?.FTUContent">
                <div class="col-md-12">
                    <f-button text="Cancel" title="Cancel" [disabled]="false" (buttonClicked)="authService.resetFTUform()"
                        type="button" variant="action"></f-button>
                    <f-button text="Validate" title="Validate" [disabled]="disableSubmit()" (buttonClicked)="authService.onSubmit()"
                        type="button" variant="progressive">
                    </f-button>
                </div>
            </div>
        </form>

        <!--Sample form AaaS-->
        <form class="hide1"  [formGroup]="aaaSService.AaaSForm"  *ngIf="rootScope.activeCustTab.IS_AAAS_ENABLED">
           
                <ng-container *ngFor="let field of aaaSService.AaaSFieldListData?.[rootScope.activeCustTab.clientId]?.ftuIdentityProvidersList
                ">
                 <div class="row row-bottom-space">
                 <div class="col-md-6 single-col padding-0">
                 
                     <mat-form-field appearance="fill" class="component-box" *ngIf="field.fieldType == 'string'">
                              <mat-label>{{field.fieldLabel}}</mat-label>
                              <input matInput [id]="field.fieldName" value="" [formControlName]="field.fieldName" autoCompleteOff />
                            </mat-form-field>

                            <mat-form-field *ngIf="field.fieldType == 'date'" appearance="fill"
                            class="component-box">
                            <mat-label>{{field.fieldLabel}}</mat-label>
                            <input matInput [id]="field.fieldName" autoCompleteOff [max]="maxDate"
                                [formControlName]="field.fieldName" [matDatepicker]="picker2" />
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                           
                        </mat-form-field>      
                    
                </div>             
            </div>
            </ng-container>
       
            <div class="row footer-btn" >
                <div class="col-md-12">
                    <f-button text="Cancel" title="Cancel" [disabled]="false" (buttonClicked)="aaaSService.resetAaaSForm()"
                        type="button" variant="action"></f-button>
                    <f-button text="Validate" title="Validate" [disabled]="false" (buttonClicked)="aaaSService.onSubmit()"
                        type="button" variant="progressive">
                    </f-button>
                </div>
            </div>
        </form>
    </div>
</div>
<div class="ftu-in-otc hide">
    <f-alert class="error-with-heading alert-info" variant="info">
        <!--CCR3-11718 UI Issue fix class added-->
        <p class="alert-top-heading">Customer Data Validated</p>
        <p>Customer is required to complete the OTC process prior to PIN creation as an additional level of security.</p>
    </f-alert>

    <app-one-time-code></app-one-time-code>
</div>

<div class="ftu-steps-container" *ngIf="authService?.FTUPanelData?.Validation&& !rootScope.activeCustTab.isNoPINClient">

    <f-alert class="error-with-heading alert-info " variant="info">
        <p class="alert-top-heading">Customer Data Validated</p>
        <p>The customer must create a PIN to complete the FTU flow.</p>
    </f-alert>

    <div class="step-container flex justify-space-between">
        <!-- step-1 -->
        <span class="step-val "
            [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step1Active || rootScope.activeCustTab.pinEntryApp?.step1Complete }">
            <span class="step-circle "
                [ngClass]="rootScope.activeCustTab.pinEntryApp?.step1Active? 'active' : 'complete'">
                <span *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Complete"> <i
                        class="fa-solid fa-check"></i></span>
                <span class="step-no" *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active">1</span>
            </span>Go to ALIS</span>
        <!-- step-2 -->
        <span class="step-val"
            [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step2Active || rootScope.activeCustTab.pinEntryApp?.step2Complete }">
            <span class="step-circle"
                [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step2Active,'complete': rootScope.activeCustTab.pinEntryApp?.step2Complete }">
                <span *ngIf="rootScope.activeCustTab.pinEntryApp?.step2Complete"> <i
                        class="fa-solid fa-check"></i></span>
                <span class="step-no" *ngIf="!rootScope.activeCustTab.pinEntryApp?.step2Complete">2</span>
            </span>Transfer the call</span>
        <!-- step-3 -->
        <span class="step-val"
            [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step3Active || rootScope.activeCustTab.pinEntryApp?.step3Complete||rootScope.activeCustTab.pinEntryApp?.pinError }">
            <span class="step-circle"
                [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step3Active,'complete': rootScope.activeCustTab.pinEntryApp?.step3Complete,'failure': rootScope.activeCustTab.pinEntryApp?.pinError }">
                <span
                    *ngIf="rootScope.activeCustTab.pinEntryApp?.step3Complete||rootScope.activeCustTab.pinEntryApp?.pinError">
                    <i class="fa-solid"
                        [ngClass]="{'fa-check': rootScope.activeCustTab.pinEntryApp?.step3Complete,'fa-xmark': rootScope.activeCustTab.pinEntryApp?.pinError }"></i></span>
                <span class="step-no"
                    *ngIf="!rootScope.activeCustTab.pinEntryApp?.step3Complete&&!rootScope.activeCustTab.pinEntryApp?.pinError">3</span>
            </span>Resume conversation</span>
    </div>
    <!-- For step-1 content  -- Pin Creation without language selection -->
    <p class="steps-content step1-content"
        *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active && !(languages?.length > 1)">
        Go to ALIS to transfer the customer to the PIN Entry App to create a PIN.
    </p>
    <!-- For step-1 content -- Pin creation with language selection -->
    <p class="steps-content step1-content"
        *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active && languages?.length > 1">
        Select the language for the PIN Entry App. Then, press the Create PIN button and go to ALIS to transfer the
        customer to PIN Entry App to create a PIN.
    </p>
    <mat-radio-group *ngIf="languages?.length > 1 && rootScope.activeCustTab.pinEntryApp?.step1Active" color="primary"
        class="account-selection" disableRipple aria-label="Select an option"
        [(ngModel)]="rootScope.activeCustTab.selectedAlisLang" (change)="onRadioChange($event.value)">
        <mat-radio-button class="delivery-method-button" *ngFor="let language of languages" [value]="language.code">
            {{language.label}}
        </mat-radio-button>
    </mat-radio-group>

    <!-- For step-2 content -->
    <p class="pin-content step2-content hide1" *ngIf="rootScope.activeCustTab.pinEntryApp?.step2Active">
        The customer will be transferred to ALIS and enter their PIN.
    </p>
    <!-- For step-3 content -->
    <p class="pin-content step3-content hide1" *ngIf="rootScope.activeCustTab.pinEntryApp?.step3Active">
        After the transfer is complete, the customer will return to the Care Portal.
    </p>
    <section *ngIf="this.rootScope.activeCustTab.pinEntryApp.pinError" class="error-wrapper">
        <f-alert variant="error">
            {{this.rootScope.activeCustTab.pinEntryApp.pinError}}
        </f-alert>

    </section>
    <div class="btn-refresh-container flex">
        <div class="btn-controls">
            <f-button text="Create PIN" title="Create PIN"
                [disabled]="!rootScope.isLiveCall && rootScope.activeCustTab.CS_SECURITY_LEVEL=='4'"
                *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active" type="button"
                (buttonClicked)="authService?.pinCreation()" variant="progressive" class=""></f-button>
            <f-button text="Try Again" title="Try Again" (buttonClicked)="cancelButton()"
                *ngIf="this.rootScope.activeCustTab.pinEntryApp.pinError" type="button" variant="progressive"
                class="hide1">
            </f-button>
            <f-button text="Cancel" title="Cancel" (buttonClicked)="cancelButton()"
                *ngIf="rootScope.activeCustTab.pinEntryApp?.step2Active" type="button" variant="action"
                class="hide1"></f-button>
        </div>
        <!-- Enable to show refresh message  -->
        <div class="refresh-link " *ngIf="rootScope.activeCustTab.pinEntryApp?.step3Active">
            <p> If the Security Level didn’t update as expected, click <button class="btn-alert"
                    (click)="genesysService.getLiveCallStatusForAuthMethod()" [ngClass]="{'disabledLink': rootScope.simulationData?.isSimulationModeActive}" >Refresh</button></p>
        </div>
    </div>
</div>

<!-- No PIN Client Validation Message -->
    <div class="ftu-steps-container" *ngIf="authService?.FTUPanelData?.Validation&&rootScope.activeCustTab.isNoPINClient">
        <f-alert class="error-with-heading alert-info " variant="info">
            <p class="alert-top-heading">Customer Data Validated</p>
            <p>{{alertMSG.NO_PIN_INFO_MSG}}</p>
        </f-alert>
    </div>